import { get } from "./http-service";

export const getLawDocumentsByCategory = async (type) => {
    const url = `/lawdocuments/${type}/categories`;

    return await get(url);
}
